import { Controller } from "@hotwired/stimulus"

// Folder picker for file sharing. The folder listing and columns are server-rendered
// via HTMX; this only tracks which folder is open and lets the Select File Path button
// close the picker instead of reloading it.
export default class extends Controller {
  static targets = ["picker"]

  open(event) {
    const entry = event.currentTarget.closest(".entry")
    entry.closest(".open-folder").querySelectorAll(".entry.is-open").forEach((el) => el.classList.remove("is-open"))
    entry.classList.add("is-open")
  }

  // Bound to htmx:confirm on the Select File Path button.
  toggle(event) {
    if (this.pickerTarget.children.length === 0) return

    event.preventDefault()
    this.pickerTarget.replaceChildren()
  }
}
